module.exports = __webpack_public_path__ + "static/img/Xavier-Ivisic.043c9ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Xavier-Ivisic.jpg
// module id = lR6d
// module chunks = 0